import React, { useState, useRef, useEffect } from 'react';
import html2canvas from 'html2canvas';
import { useAnalysisResults } from '../../../store/plateWellStore';
import { formatValue } from '../../../utils/basic';
import Download2Pdf from '../../common/Download2Pdf';

//TODO: consolidate replicate and control analysis in one display - since now both are almost same check with API folks

const ReplicateAnalysisDisplay = () => {

    const analysiResults = useAnalysisResults();
    const tableRef = useRef(null);
    const [imageSrc, setImageSrc] = useState('');
    //Generate data for PDF and UI display - one common data structure

    const stats = analysiResults.map(item => item?.statistic);
    const metrics = ["Mean", "Stdev"];
    const tableHeaders = [[], []];
    tableHeaders[0].push("Replicate", "# Wells", ...stats);
    tableHeaders[1].push("", "", ...metrics.flatMap(metric => [metric, metric]));

    const groupedData = analysiResults?.reduce((acc, item) => {
        if (!acc[item?.Replicate]) {
            acc[item?.Replicate] = { wells: item?.wells, stats: {} };
        }
        if (!acc[item?.Replicate].stats[item?.statistic]) {
            acc[item?.Replicate].stats[item?.statistic] = {
                Mean: item?.Mean,
                Stdev: item?.Stdev,
            };
        }
        return acc;
    }, {});

    // Get the list of statistics
    const statistics = [...new Set(analysiResults?.map((item) => item?.statistic))];
    useEffect(() => {
        const captureTable = async () => {
            try {

                const table = tableRef.current;
                // Calculate content height (using a wrapper)
                const tableBodyWrapper = table.querySelector('.table-body-wrapper'); // Get the wrapper element
                const contentHeightTableBody = tableBodyWrapper.offsetHeight;



                const tableHeadWrapper = table.querySelector('.table-head-wrapper');
                const firstRow = tableHeadWrapper.querySelector('tr'); // Get the first row
                const contentWidth = firstRow.offsetWidth;
                const contentHeightTableHead = tableHeadWrapper.offsetHeight;
                const contentHeight = contentHeightTableHead + contentHeightTableBody;

                // Set table height to content height
                table.style.height = `${contentHeight}px`;

                // Set table width to content width
                table.style.width = `${contentWidth}px`;
                // Calculate required dimensions
                const canvas = await html2canvas(table, {
                    scale: 1,
                    width: contentWidth,
                    height: contentHeight,
                    x: 0,
                    y: 0,
                    windowWidth: contentWidth,
                    windowHeight: contentHeight
                });

                // const imgData = canvas.toDataURL('image/jpeg', 1.0);

                // Create a new canvas with the desired dimensions
                const newCanvas = document.createElement('canvas');
                newCanvas.width = contentWidth;
                newCanvas.height = contentHeight;
                const ctx = newCanvas.getContext('2d');

                // Draw the original canvas onto the new canvas
                ctx.drawImage(canvas, 0, 0, newCanvas.width, newCanvas.height);
                const resizedImgData = newCanvas.toDataURL('image/jpeg', 1.0);

                setImageSrc(resizedImgData);
            } catch (error) {
                console.error('Error capturing table:', error);
            }
        };

        // Capture the table image after a short delay to ensure the table is fully rendered
        setTimeout(captureTable, 1000);
    }, []);
    const handleImageClick = () => {
        if (!imageSrc) return;

        const newWindow = window.open();

        const img = newWindow.document.createElement('img');
        img.src = imageSrc;
        img.alt = 'Captured Table';
        // img.style.width = '100%';

        newWindow.document.body.appendChild(img);
    };
    return (
        // <div className="border-2 border-solid rounded-sm border-custom-green overflow-auto w-[90vh]">
        <div className="border-2 border-solid rounded-sm border-custom-green overflow-auto w-[100vh]">
            <div className="flex items-end p-5 gap-x-1">
                <div className="flex-grow" />
                {imageSrc ? <img
                    src={imageSrc}
                    alt="Captured Table"
                    className="minified-icon border border-custom-green rounded-[8px] cursor-pointer p-1"
                    style={{ width: '50px', height: '50px', cursor: 'pointer' }}
                    draggable
                    onClick={handleImageClick}
                /> : <div className="spinner-container">
                    <div className="spinner" />
                    <div className="loading-text">Loading...</div>
                </div>
                }
                <Download2Pdf reportData={groupedData} reportType="variableCol" statistics={statistics} />
            </div>
            {/* <div style={{ width: `${totalWidth}%` }}> */}
            <table className="p-1 w-full divide-y divide-gray-200 max-h-none" ref={tableRef}>
                <thead className="bg-gray-50 table-head-wrapper">
                    <tr>
                        <th className="whitespace-nowrap px-3 py-2 text-left text-[11px] font-medium text-black uppercase tracking-wider" rowSpan="2">Replicate</th>
                        <th className="whitespace-nowrap px-3 py-2 text-left text-[11px] font-medium text-black uppercase tracking-wider" rowSpan="2"># Wells</th>
                        {statistics?.map((stat, index) => (
                            <th className="whitespace-nowrap px-3 py-2 text-left text-[10px] font-medium text-black uppercase tracking-wider" colSpan="2" key={index}>{stat}</th>
                        ))}
                    </tr>
                    <tr>
                        {statistics?.map((stat, index) => (
                            <React.Fragment key={index}>
                                <th className="whitespace-nowrap px-3 py-2 text-left text-[11px] font-medium text-black">Mean</th>
                                <th className="whitespace-nowrap px-3 py-2 text-left text-[11px] font-medium text-black">Stdev</th>
                            </React.Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200 table-body-wrapper">
                    {Object.keys(groupedData).map((replicate, index) => (
                        <tr key={index}>
                            <td className="whitespace-nowrap px-3 py-2 text-[11px] text-black">{replicate}</td>
                            <td className="whitespace-nowrap px-3 py-2 text-[11px] text-black">{groupedData[replicate].wells}</td>
                            {statistics?.map((stat, idx) => (
                                <React.Fragment key={idx}>
                                    <td className="whitespace-nowrap px-3 py-2 text-[11px] text-black">{formatValue(groupedData[replicate].stats[stat]?.Mean)}</td>
                                    <td className="whitespace-nowrap px-3 py-2 text-[11px] text-black">{formatValue(groupedData[replicate].stats[stat]?.Stdev)}</td>
                                </React.Fragment>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            {/* </div> */}
        </div>


    )
}

export default ReplicateAnalysisDisplay;


// Calculate dynamic width based on the number of statistics
// Calculate dynamic width based on the number of statistics
// const baseWidth = 10; // Base width in pixels for non-statistic columns
// const extraWidthPerStat = 5; // Extra width per statistic (Mean and Stdev) in pixels
// const totalWidth = baseWidth + statistics?.length * extraWidthPerStat;

// const desiredWidth = 13.9 * 300; // Width in pixels
// const desiredHeight = 6.38 * 200; // Height in pixels

// const dpi = 100; // standard screen DPI
// const baseWidthInches = 2; // Base width in inches for non-statistic columns
// const columnWidthInches = 3; // Width in inches per statistic column
// const desiredHeightInches = 10.38; // Fixed height in inches - R2 need to get all replicates from API for the file to calc the height

// //const numColumns = 2 + statistics.length * 2; // 2 base columns (Replicate, # Wells) + 2 columns per statistic (Mean, Stdev)
// const desiredWidthInches = baseWidthInches + (statistics?.length * columnWidthInches * 1); // Calculate the total width in inches
// console.log("desiredWidthInches", desiredWidthInches, desiredHeightInches);
// const desiredWidth = desiredWidthInches * 100; // Width in pixels
// const desiredHeight = desiredHeightInches * 100; // Height in pixels
// console.log("desiredWidth", desiredWidth, desiredHeight);

//const computedStyles = window.getComputedStyle(table);


// Example: Get font size
//const originalFontSize = computedStyles.getPropertyValue('font-size');



// Apply temporary styles for capturing
//table.style.fontSize = '46px'; // Set the font size you need

// older way of doing it - before 925 new ask for all stats in pdf report - DCA-729

// Helper: group data by replciate ( actually sample name)
// const groupedData = new Map();

// for (const item of analysiResults) {


//     const { Replicate, statistic, ...rest } = item;
//     if (!groupedData.has(Replicate)) {
//         groupedData.set(Replicate, { Replicate, items: [], totalWells: 0 });
//     }

//     const replicateData = groupedData.get(Replicate);
//     replicateData.items.push({ statistic, ...rest });
//     replicateData.totalWells = item.wells;

// }

// // check if data is availabe
// const hasData = groupedData?.size > 0;

// //Table Rendering
// //Helper: create a custom iterable object
// // using generators here for better performance
// function* getIterableView(map) {
//     for (const [key, value] of map) {
//         yield value;
//     }
// }


/* <table className="w-max divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="whitespace-nowrap px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" rowSpan="2">Replicate</th>
                        <th className="whitespace-nowrap px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" rowSpan="2"># Wells</th>
                        {hasData && groupedData.values().next().value.items.map((item, index) => (
                            <th className="whitespace-nowrap px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan="2" key={index}>{item.statistic}</th>
                        ))}
                    </tr>
                    <tr>
                        {hasData && groupedData.values().next().value.items.map((item, index) => (
                            <React.Fragment key={index}>
                                <td className="whitespace-nowrap px-6 py-2 text-left text-xs font-medium text-gray-500">Mean</td>
                                <td className="whitespace-nowrap px-6 py-2 text-left text-xs font-medium text-gray-500">Stdev</td>
                            </React.Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {[...getIterableView(groupedData)].map((replicateData, index) => (
                        <tr key={`replicate-${index}`}>
                            <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{replicateData?.Replicate}</td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{replicateData.totalWells}</td>
                            {replicateData.items.map((item, itemIndex) => (
                                <React.Fragment key={`item-${index}-${itemIndex}`}>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{formatValue(item.Mean)}</td>
                                    <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{formatValue(item.Stdev)}</td>

                                </React.Fragment>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table> */